import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';
import { FilterComponentBase } from 'src/app/main/filter-component-base';
import locale from 'date-fns/locale/pt';
import { toDate } from 'date-fns/esm';

@Component({
  selector: 'app-filter-datepicker',
  templateUrl: './filter-datepicker.component.html',
  styleUrls: ['./filter-datepicker.component.scss']
})
export class FilterDatepickerComponent extends FilterComponentBase implements OnInit {
  @ViewChild('datepicker') datepicker: ElementRef;

  constructor() {
    super()
  }

  date: Date;
  placeholder: string = ''
  options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    format: 'dd/MM/yyyy',
    formatTitle: 'MMMM yyyy',
    formatDays: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: locale,
    placeholder: this.placeholder, // HTML input placeholder attribute (default: '')
    // inputClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    //calendarClass: "datepicker-container datepicker-default container"
  };

  ngOnInit() {
    this.options.placeholder = this.getPlaceholder()

    this.loadDate()
  }

  private loadDate() {
    if (this.attribute.value) {
      this.date = new Date(this.attribute.value);
      if(this.datepicker){
        this.datepicker['displayValue']=this.date
      }
    } else {
      this.date = null;
    }
  }

  changedDate(event) {
    this.date = new Date(event);
    this.attribute.value = this.date.toISOString();
    this.emit({
      attribute: this.attribute
    });
  }

  clearDate(){
    this.datepicker['displayValue']=''
    this.date = undefined
    this.attribute.value = undefined
    this.emit({
      attribute: this.attribute
    });
  }
}
